import { CitationsGridComponent } from './citations-grid.component';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { useCitationsContext } from '@vivli/shared/features/citations/infrastructure/context';
import { Styles } from '@vivli/shared/theme';
import { CitationsAddButtonsComponent } from './citation-add-buttons.component';
import { DTIAMRAgGrid } from '@vivli/shared/infrastructure/constants';

interface CitationsContainerComponentProps {
    objectId: string;
    isStudy: boolean;
    doUpdate: boolean;
    dataRequestDoiStem: string;
}

export const CitationsContainerComponent = ({isStudy, dataRequestDoiStem}: CitationsContainerComponentProps) => {
    const { citations, permissions, isLoading } = useCitationsContext();
    const canModify = permissions.canModifyCitation && !isStudy;

    return (
        <div>
            {canModify && (
                <div style={Styles.FORM_ROW}>
                    <CitationsAddButtonsComponent />
                </div>
            )}
            {isLoading && <LoadIndicatorCenteredView />}

            <CitationsGridComponent
                citations={citations}
                dataRequestDoiStem={dataRequestDoiStem}
                emptyMessage={'No citations found'}
                hideFloatingFilter={true}
                hideHeader={true}
                autoHeight={true}
                data-test-id={DTIAMRAgGrid.CitationsGrid}
            />
        </div>
    );
};
